var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.42 9.72-6.14-6.14s-.69-.72 0-1.84c.92-.92 1.84 0 1.84 0l6.14 6.14s.92.92 0 1.84c-1.03.7-1.84 0-1.84 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.33 10.03s-2.45-.61-3.37.3l-4 4-4.29-4.3 4-3.99c.91-.92.3-3.38.3-3.38l7.36 7.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.97 19.85-9.82-9.82s.3-.92 1.54-.92c1.22 0 3.68 1.22 4.9 0l4.3 4.3c-1.23 1.22 0 3.68 0 4.9 0 1.23-.92 1.54-.92 1.54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39 22.61C.78 22 5.38 17.4 5.38 17.4l3.07-3.06 1.23 1.22-3.07 3.07s-4.6 4.6-5.22 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinlarge);
export default __webpack_public_path__ + "static/media/pin.large.d454d9fc4207dd200fb54086ebac4ac6.svg";
export { ForwardRef as ReactComponent };